<template>
    <div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="转移减量" name="first"></el-tab-pane>
            <el-tab-pane label="转移仓库" name="second"></el-tab-pane>
        </el-tabs>
        <div style="margin: 0 0 12px 0;">
            <div style="display: flex;align-items: center;margin-bottom: 12px;">
                <el-input v-model="form.userId" style="width: 220px;" placeholder="请输入UID"></el-input>
                <el-select v-model="form.status" style="width: 220px;margin: 0 12px;" placeholder="请选择类型">
                    <el-option label="成功" :value="1"></el-option>
                    <el-option label="失败" :value="2"></el-option>
                </el-select>
                <el-date-picker is-range format="yyyy-MM-dd" clearable v-model="time" type="daterange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="pickerChange"
                    style="width: 280px;margin: 0 12px 0 0;">
                </el-date-picker>
                <el-button type="primary" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="noserch">重置</el-button>
                <el-button type="primary" @click="exportData">导出</el-button>
            </div>
            <div style="display:flex;align-items:flex-start">
                <el-upload class="upload-demo" ref="wordupload" action="#" accept=".xlsx" :show-file-list="true" :limit="1"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :before-remove="beforeRemove"
                    :http-request="mainPicUpload">
                    <el-button type="primary">导入</el-button>
                </el-upload>
                <el-button type="success" style="margin-left:20px" @click="confirmSend">确认操作</el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading">
                <template v-if="activeName === 'first'">
                    <el-table-column prop="userId" label="用户ID" :key="1"></el-table-column>
                    <el-table-column prop="subNum" label="减量可用余额" :key="2"></el-table-column>
                    <el-table-column prop="subPositionNum" label="减量仓库余额" :key="3"></el-table-column>
                    <el-table-column label="状态" :key="9">
                        <template v-slot="{ row }">
                            {{
                                row.status == 1
                                ? "成功"
                                : row.status == 2
                                    ? "失败"
                                    : ""
                            }}
                        </template></el-table-column>
                    <el-table-column prop="failReason" label="划拨失败原因" :key="4"> </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" :key="5"> </el-table-column>
                </template>
                <template v-if="activeName === 'second'">
                    <el-table-column prop="userId" label="用户ID" :key="6"></el-table-column>
                    <el-table-column prop="num" label="仓位增加数量" :key="7"></el-table-column>
                    <el-table-column prop="positionId" label="仓位id" :key="8"></el-table-column>
                    <el-table-column label="状态" :key="10">
                        <template v-slot="{ row }">
                            {{
                                row.status == 1
                                ? "成功"
                                : row.status == 2
                                    ? "失败"
                                    : ""
                            }}
                        </template></el-table-column>
                    <el-table-column prop="failReason" label="划拨失败原因" :key="11"> </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" :key="12"> </el-table-column>
                </template>
            </el-table>
        </div>
        <!-- 底部分页 -->
        <div class="pagination" style="margin-top: 24px; text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="form.currentPage" :page-sizes="[10, 15, 20, 30]" :page-size="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
const xlsx = require("xlsx");
import { xmlUrl } from '../../utils/xmlurl'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
    data() {
        return {
            activeName: 'first',
            file: null,
            form: {
                userId: '',
                status: '',
                currentPage: 1,
                pageSize: 20,
                startTime: '',
                endTime: '',
            },
            time: [],
            tableData: [],
            total: 0,
            tableLoading: false
        };
    },
    created() {
        this.getList()
    },
    methods: {
        // 获取所有需要导出的数据
        exportData() {
            this.$message.success('生成中，请稍候');
            let api1 = '', api2 = '', str = ''
            if (this.activeName === 'first') {
                api1 = '/admin/addGen/setAddGenRedis'
                api2 = '/admin/addGen/getAddGenRedis'
                str = '转移减量.xlsx'
            } else {
                api1 = '/admin/addGen/setAddPositionNumRedis'
                api2 = '/admin/addGen/getAddPositionNumRedis'
                str = '转移仓库.xlsx'
            }
            this.axios.get(api1, this.form).then(() => {
                setTimeout(() => {
                    this.axios.get(api2)
                        .then(res => {
                            let data = []
                            if (this.activeName === 'first') {
                                data = [
                                    ["用户ID", "减量可用余额", "减量仓库余额", "状态", "划拨失败原因", "创建时间"],
                                ]
                            } else {
                                data = [
                                    ["用户ID", "仓位增加数量", "仓位id", "状态", "划拨失败原因", "创建时间"],
                                ]
                            }
                            let arr = res.data.data
                            arr.map((item, i) => {
                                if (this.activeName === 'first') {
                                    data.push([item.userId, item.subNum, item.subPositionNum, item.status == 1
                                        ? "成功"
                                        : item.status == 2
                                            ? "失败"
                                            : "", item.failReason, item.createTime])
                                } else {
                                    data.push([item.userId, item.num, item.positionId, item.status == 1
                                        ? "成功"
                                        : item.status == 2
                                            ? "失败"
                                            : "", item.failReason, item.createTime])
                                }
                            })
                            // 将数据转换为工作表
                            const worksheet = XLSX.utils.aoa_to_sheet(data);

                            // 创建工作簿并添加工作表
                            const workbook = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                            // 生成Excel文件并导出
                            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                            const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
                            saveAs(dataBlob, str);
                        })
                }, 2000);
            })
        },
        doFilter() {
            this.getList();
        },
        // 时间
        pickerChange(val) {
            this.form.startTime = val[0]
            this.form.endTime = val[1]
        },
        noserch() {
            this.form.userId = "";
            this.form.status = "";
            this.form.startTime = ''
            this.form.endTime = ''
            this.form.currentPage = 1;
            this.form.pageSize = 20;
            this.time = []
            this.getList();
        },
        handleClick(tab, event) {
            this.activeName = tab.name
            this.noserch()
        },
        handleAvatarSuccess(res, file) {
            // console.log(res, file)
        },
        beforeAvatarUpload(file) {
        },
        mainPicUpload({ file }) {
            this.file = file
        },
        beforeRemove(file, fileList) {
            this.file = null
        },
        getList() {
            let url = ''
            this.tableLoading = true
            if (this.activeName == 'first') {
                url = '/admin/addGen/findTransferGenList'
            } else {
                url = '/admin/addGen/findTransferPositionNumList'
            }
            this.axios.get(url, this.form).then((res) => {
                this.tableLoading = false
                this.tableData = res.data.data.records;
                this.total = res.data.data.total;
            });
        },
        confirmSend() {
            if (!this.file) {
                this.$message('请先上传文件')
                return
            }
            let form = new FormData()
            form.set('file', this.file)
            let url = ''
            if (this.activeName == 'first') {
                url = '/admin/addGen/transferGen'
            } else {
                url = '/admin/addGen/transferPosition'
            }
            this.axios.post(url, form).then((res) => {
                if (res.data.code == 200) {
                    this.file = null
                    this.$message.success(res.data.mesg)
                    this.$refs.wordupload.clearFiles();
                    this.getList()
                } else {
                    this.$message.error(res.data.data)
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.form.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.form.currentPage = val
            this.getList()
        },
    }
};
</script>